import { useSelector } from 'react-redux'
import find from 'lodash/find'

import { RootState } from 'types'
import { useCurrentWorkspaceIdWithProject } from './useCurrentWorkspaceIdWithProject'

// The workspace a file mutation actually targets — the same id useUpdateFile sends to.
// That is the Redux current workspace, except when browsing a folder from the Almanac
// core workspace, where it is the folder's real owner. Workspace-level settings that
// gate a mutation (post_approval_enabled, for one) must be read from this workspace;
// useCurrentWorkspace would answer for the core workspace there. Returns undefined
// when the effective workspace is not in the Redux workspace list.
export const useCurrentWorkspaceWithProject = () => {
  const workspaceId = useCurrentWorkspaceIdWithProject()

  return useSelector(({ workspace }: RootState) =>
    workspaceId === undefined ? undefined : find(workspace.workspaces, { id: workspaceId }),
  )
}
